import { getObjectValue } from '@services/object-extensions';
import { useState } from 'react';
import { Accordion } from '@components/common/accordion/accordion';
import PLUS from '@svg/plus.svg';
import CROSS from '@svg/cross.svg';

const AdditionalContentAccordionGroup = ({ translations = {}, darkTheme = false, id = '' }) => {
  const [open, setOpen] = useState({});

  return (
    <>
      {getObjectValue(translations, 'additionalInfo', [])?.map((element, index) => (
        <div className="row mb-3" key={`${id}-accordion-${index + 1}`}>
          <div className="col-12 p-0 snf-font-16">
            <Accordion
              head={getObjectValue(element, 'title', '')}
              open={open[`accordion${index + 1}`]}
              setOpen={(state) => setOpen({ ...open, [`accordion${index + 1}`]: state })}
              darkTheme={darkTheme}
              Icon={open[`accordion${index + 1}`] ? CROSS : PLUS}
              iconColor={darkTheme ? 'white' : '#1576b0'}
              backgroundColor={darkTheme ? 'rgba(255, 255, 255, 0.3)' : undefined}
            >
              <div className="pb-3">
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: getObjectValue(element, 'body', '')
                  }}
                />
              </div>
            </Accordion>
          </div>
        </div>
      ))}
    </>
  );
};

AdditionalContentAccordionGroup.displayName = 'Additional Content Accordion Group ';
export { AdditionalContentAccordionGroup };
